import * as _ from 'lodash';

function calcNextMonth(round) {
    if (round.Month === 12) {
        return { year: round.Year + 1, month: 1 };
    } else {
        return { year: round.Year, month: round.Month + 1 };
    }
}

function getPaymentMonthToday() {
    var today = new Date();
    return { year: today.getFullYear(), month: today.getMonth() + 1 }; // JS month i 0-based.
}

function isCurrentMonth(round) {
    if (!round) return false;
    var today = new Date();
    return round.Year === today.getFullYear() && round.Month === today.getMonth() + 1;
}

angular.module("tromanWeb").controller('WageGroupTransactionsController', ['$q', 'stateService', 'tromanServer', 'dialogService', 'downloadService', 'reportService', 'systemInfo', 'userProfile', 'wageGroupShared', function ($q, stateService, tromanServer, dialogService, downloadService, reportService, systemInfo, userProfile, wageGroupShared) {
    this.busy = false;

    this.$onInit = function $onInit() {
        this.wageGroup = wageGroupShared.wageGroup;
        this.current = this.wageGroup.CurrentRound;
        this.systemInfo = systemInfo;
        this.isCurrentMonth = isCurrentMonth(this.current?.PaymentRound);

        if (this.current != null) {
            this.round = this.current.PaymentRound;
            this.sendername = this.round.SenderName;
        } else {
            this.addMode = true;
            this.newMonth = getPaymentMonthToday();
            this.sendername = userProfile.name;
        }
    };

    this._block = function _block(promise) {
        $q(resolve => {
            this.busy = true;
            resolve(promise);
        }).finally(() => this.busy = false);
    };

    this.canShowAddMode = function canShowAddMode() {
        if (this.busy) return false;
        return this.round != null && this.round.IsLocked;
    };

    this.showAddMode = function showAddMode(enabled) {
        if (!this.canShowAddMode()) return false;

        this.addMode = !!enabled;
        this.newMonth = calcNextMonth(this.round);
        this.sendername = this.round.SenderName;
    };

    this._doAddRound = function (next, sendername) {
        let promise = tromanServer.WageGroups
            .addRound(this.wageGroup, next.year, next.month, sendername)
            .then(() => stateService.reload())
            .catch(dialogService.error);
        this._block(promise);
    };

    this.canAddNext = function canAddNext() {
        if (this.busy) return false;
        if (this.nextForm == null || !this.nextForm.$valid) return false;

        return this.round != null && this.round.IsLocked;
    };

    this.addNext = function addNext() {
        if (!this.canAddNext()) return;

        if (!this.round.FileDate && this.round.NumberOfPayments > 0) {
            const promise = dialogService.confirm([
                "Vill du gå till nästa lönemånad?",
                "Transaktionsfil är ännu inte hämtad.",
                `Om du går till nästa lönemånad så kommer ${this.round.NumberOfPayments} inlästa poster inte komma med.`,
            ]).then(() => this._addNext());
    
            this._block(promise);
        }
        else {
            this._addNext();
        }
    };

    this._addNext = function() {
        this._doAddRound(calcNextMonth(this.round), this.sendername);
    };

    this.canAddNew = function canAddNew() {
        if (this.busy) return false;
        if (this.addForm == null || !this.addForm.$valid) return false;
        if (this.newMonth == null) return false;

        return this.round == null || this.round.IsLocked;
    };

    this.addNew = function addNew() {
        if (!this.canAddNew()) return;
        this._doAddRound(this.newMonth, this.sendername);
    };

    this.canLockRound = function canLockRound() {
        if (this.busy) return false;
        if (this.round == null) return false;
        if (this.round.IsReadOnly) return false;

        return !this.round.IsLocked;
    };

    this.lockRound = function lockRound() {
        if (!this.canLockRound()) return;

        if (this.round.NumberOfPayments === 0) {
            const promise = dialogService.confirm([
                "Vill du låsa lönemånaden?",
                "Lönemånaden innehåller inga inlästa poster. Attestlista och transaktionsfil kommer vara tomma.",
            ]).then(() => this._lockRound());
    
            this._block(promise);
        }
        else {
            this._lockRound();
        }
    };

    this._lockRound = function() {
        let promise = tromanServer.WageGroups
            .lockRound(this.wageGroup, true)
            .then(() => stateService.reload())
            .catch(dialogService.error);
        this._block(promise);
    };

    this.showUnlockRound = function showUnlockRound() {
        return !!(this.round && this.round.IsLocked);
    };

    this.canUnlockRound = function canUnlockRound() {
        if (this.busy) return false;
        if (this.round == null) return false;
        if (this.round.IsReadOnly) return false;

        return !!this.round.IsLocked;
    };

    this.unlockRound = function unlockRound() {
        if (!this.canUnlockRound()) return;

        let promise = dialogService.confirm([
            "Vill du låsa upp lönemånaden?",
            "När man låser upp lönemånad och läser in poster så kommer både de tidigare posterna i samma månad, " +
            "samt eventuellt nya, med när man skapar ny transaktionsfil och attestlista.",
        ]).then(() => {
            return tromanServer.WageGroups
                .lockRound(this.wageGroup, false)
                .then(() => stateService.reload())
                .catch(dialogService.error);
        });

        this._block(promise);
    };

    this.canRemoveRound = function canRemoveRound() {
        if (this.busy) return false;
        if (this.round == null) return false;

        return this.round != null;
    };

    this.removeRound = function removeRound() {
        if (!this.canRemoveRound()) return;

        let promise = dialogService.confirm(['Ta bort lönemånaden.', 'All information kopplad till lönemånaden, t.ex. versioner, transaktionsfiler och koppling till arvoden (dock inte arvodena själva) kommer tas bort.', 'Är du säker?'])
            .then(() =>
                tromanServer.WageGroups
                    .removeRound(this.wageGroup)
                    .then(() => stateService.reload())
                    .catch(dialogService.error))
            .catch(_.noop);
        this._block(promise);
    };

    this.canAddVersion = function canAddVersion() {
        if (this.busy) return false;
        if (this.round == null) return false;
        if (this.round.IsReadOnly) return false;
        if (this.nextForm == null || !this.nextForm.$valid) return false;

        return !this.round.IsLocked;
    };

    this.addVersion = function addVersion() {
        let promise = tromanServer.WageGroups
            .addVersion(this.wageGroup, this.sendername)
            .then(() => stateService.reload())
            .catch(dialogService.error);
        this._block(promise);
    };

    this.canDownloadFile = function canDownloadFile() {
        if (this.busy) return false;
        return this.round != null && this.round.HasTransactionData && this.round.IsLocked;
    };

    this.downloadFile = function downloadFile() {
        if (!this.canDownloadFile()) return;

        let promise = tromanServer.PaymentRounds
            .downloadFile(this.round)
            .then(rsp => {
                downloadService.downloadBlob(rsp.blob, rsp.filename);
                stateService.reload();
            })
            .catch(dialogService.error);
        this._block(promise);
    };

    this.canDownloadReport = function canDownloadReport() {
        if (this.busy) return false;
        return this.round != null && this.round.HasTransactionData;
    };

    this.canDownloadPreviewReport = function canDownloadPreviewReport() {
        return this.round != null && this.round.HasTransactionData && this.round.NumberOfPayments > 0;
    };

    this.canDownloadAttestationReport = function canDownloadAttestationReport () {
        return this.canDownloadReport() && this.round.IsLocked;
    };

    this.downloadReport = function downloadReport(splitAttestation) {
        if (!this.canDownloadReport()) return;

        var pars = {
            Options: { Format: 1, SplitAttestation: splitAttestation },
            Query: { PaymentRoundId: this.round.Id }
        };

        let promise = reportService
            .generate('Attestation', pars)
            .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename))
            .catch(dialogService.error);
        this._block(promise);
    };
}]);

